import { useDispatch, useSelector } from 'react-redux';
import './css/app.css'
import './css/common.css'
import { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom"
import { change_Current_Location, changeHeaderTitle } from '../store';
import dayjs from 'dayjs';
import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn } from './component/search/search';
import { ChevronsDown, ChevronsUp, ChevronUp, ChevronDown } from 'lucide-react';
import Chart from 'react-apexcharts';
import List from './component/list/list';
import axios from 'axios';
import { changeNum, convertDateFormat, convertDate } from './common/function';
import { DownloadBtn } from './component/btn/btn';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

function Dashboard() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const MyData = useSelector((state) => state.MyData);
    let pgChoose = useSelector((state) => { return state.pgChoose.value })

    // =====================
    // 서버/대시보드 데이터
    // =====================
    const [settlementData, setSettlementData] = useState([]);
    const [dashboardData, setDashboardData] = useState([]);
    const [dashabordFeeData, setDashboardFeeData] = useState([]);
    const [todaySettlementData, setTodaySettlementData] = useState([]);
    const [rmData, setRmData] = useState([])
    const [subRenewal, setSubRenewal] = useState([])

    const [dailyData, setDailyData] = useState([]);
    const [monthData, setMonthData] = useState([]);
    const [rmAmountDailyData, setRmAmountDailyData] = useState([]);
    const [rmAmountMonthData, setRmAmountMonthData] = useState([]);
    const [rmFrequencyDailyData, setRmFrequencyDailyData] = useState([]);
    const [rmFrequencyMonthData, setRmFrequencyMonthData] = useState([]);

    const [rmAmountCnt, setRmAmountCnt] = useState(0)
    const [subRenewalCnt, setSubRenewalCnt] = useState(0)
    const [sugiCnt, setSugiCnt] = useState(0)
    const [sugiCancelCnt, setSugiCancelCnt] = useState(0)

    // 수기 결제 / 취소 신청 데이터
    const [dashboardSugiData, setDashboardSugiData] = useState([]);
    const [dashboardSugiCancelData, setDashboardSugiCancelData] = useState([]);

    // =====================
    // 토글 상태 (모바일 <767)
    // =====================
    const [showSales, setShowSales] = useState(false);
    const [showWallet, setShowWallet] = useState(false);
    const [showSogi, setShowSogi] = useState(false);
    const [showSogiCancel, setShowSogiCancel] = useState(false);
    const [showRm, setShowRm] = useState(false);
    const [showSettlementDay, setShowSettlementDay] = useState(false);
    const [showLiveSales, setShowLiveSales] = useState(false);
    const [showLiveTransaction, setShowLiveTransaction] = useState(false);

    // =====================
    // 반응형: windowWidth
    // =====================
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    // =====================
    // 년/월 select 동적 생성
    // =====================
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    // 'monthly' => 일별, 'yearly' => 월별
    const [period, setPeriod] = useState('monthly');
    const [selectedYear, setSelectedYear] = useState(currentYear);
    const [selectedMonth, setSelectedMonth] = useState(currentMonth);

    const [rmPeriod, setRmPeriod] = useState('monthly');
    const [rmSelectedYear, setRmSelectedYear] = useState(currentYear);
    const [rmSelectedMonth, setRmSelectedMonth] = useState(currentMonth);

    // 2024 ~ 현재연도까지
    const yearList = [];
    for (let y = 2024; y <= currentYear; y++) {
        yearList.push(y);
    }

    // 현재 연도면 1~currentMonth까지, 과거 연도면 1~12
    const getMonthList = () => {
        if (selectedYear === currentYear) {
            return Array.from({ length: currentMonth }, (_, i) => i + 1);
        } else {
            return Array.from({ length: 12 }, (_, i) => i + 1);
        }
    };
    const monthList = getMonthList();

    // =====================
    // 초기 데이터 호출
    // =====================
    useEffect(() => {
        // (예시) 리덕스 상태 업데이트
        dispatch(change_Current_Location('대시보드'));
        dispatch(changeHeaderTitle({ mainTitle: '대시보드', subTitle: '' }));

        DashboardData();
        DashboardSugiData();
        DashboardSugiCancelData();
        DashboardRmData()
        DashboardSubRenewalData()

        // 10초마다 리프레시
        const interval = setInterval(() => {
            DashboardData();
        }, 10000);

        // resize
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
        };
        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            clearInterval(interval);
            window.removeEventListener('resize', handleResize);
        };
    }, [dispatch]);

    // =====================
    // width>767 => 모두 open
    // width<=767 => 모두 close
    // =====================
    useEffect(() => {
        if (windowWidth > 767) {
            setShowSales(true)
            setShowWallet(true)
            setShowSogi(true);
            setShowSogiCancel(true);
            setShowRm(true);
            setShowSettlementDay(true);
            setShowLiveSales(true);
            setShowLiveTransaction(true);
        } else {
            setShowSales(false)
            setShowWallet(false)
            setShowSogi(false);
            setShowSogiCancel(false);
            setShowRm(false);
            setShowSettlementDay(false);
            setShowLiveSales(false);
            setShowLiveTransaction(false);
        }
    }, [windowWidth]);

    // =====================
    // Dashboard API
    // =====================
    const DashboardData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/dashboard', {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setSettlementData(tmp?.realtime?.realtimeSettlementRows ?? []);
                setDashboardData(tmp?.realtime?.realtimeRows[0] ?? []);
                setDashboardFeeData(tmp?.realtime?.realtimeAgencyRows[0] ?? []);
                setTodaySettlementData(tmp?.realtime?.todaySettlementRows[0] ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardSugiData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/dashboard/sugi', {
                withCredentials: true,
            });
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setDashboardSugiData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardSugiCancelData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/dashboard/sugi/cancel', {
                withCredentials: true,
            });
            let tmp = response?.data;
            console.log(tmp)
            if (tmp?.code < 2000) {
                setDashboardSugiCancelData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardRmData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/trx/pending-high-value', {
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setRmData(tmp?.data?.pending_items?.slice(0, 4) ?? []);
                setRmAmountCnt(tmp?.data?.total_count ?? 0)
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardSubRenewalData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/merchant-renewal-urgent', {
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setSubRenewal(tmp?.data?.urgent_renewals?.slice(0, 4) ?? []);
                setSubRenewalCnt(tmp?.data?.totCnt ?? 0)
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    // 년/월/대행사 바뀔 때마다 일별/월별 API 재조회
    useEffect(() => {
        DashboardDailyData();
        DashboardMonthData();
        DashboardRMAmountDailyData(selectedYear, selectedMonth);
        DashboardRMAmountMonthData(selectedYear, selectedMonth);
        DashboardRMFrequencyDailyData(selectedYear, selectedMonth);
        DashboardRMFrequencyMonthData(selectedYear, selectedMonth);
    }, [selectedYear, selectedMonth, pgChoose]);

    const DashboardDailyData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/dashboard/daily', {
                params: {
                    month: `${selectedYear}-${String(selectedMonth).padStart(2, '0')}`,
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setDailyData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardMonthData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/dashboard/monthly', {
                params: {
                    year: selectedYear,
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setMonthData(tmp?.data ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };


    useEffect(() => {
        // DashboardRMAmountDailyData(rmSelectedYear,rmSelectedMonth);
        // DashboardRMAmountMonthData(rmSelectedYear,rmSelectedMonth);
        // DashboardRMFrequencyDailyData(rmSelectedYear,rmSelectedMonth);
        // DashboardRMFrequencyMonthData(rmSelectedYear,rmSelectedMonth);
    }, [rmSelectedYear, rmSelectedMonth, pgChoose]);

    const DashboardRMAmountDailyData = async (year, month) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/trx/daily-trend', {
                params: {
                    year: year,
                    month: String(month).padStart(2, '0'),
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setRmAmountDailyData(tmp?.data?.daily_trend ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardRMAmountMonthData = async (year, month) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/trx/monthly-trend', {
                params: {
                    year: year,
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setRmAmountMonthData(tmp?.data?.monthly_trend ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardRMFrequencyDailyData = async (year, month) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/trx/duplicates/daily-trend', {
                params: {
                    year: year,
                    month: String(month).padStart(2, '0'),
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setRmFrequencyDailyData(tmp?.data?.daily_trend ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };

    const DashboardRMFrequencyMonthData = async (year, month) => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + '/api/rm/trx/duplicates/monthly-trend', {
                params: {
                    year: year,
                    sm: pgChoose,
                },
                withCredentials: true,
            });
            let tmp = response?.data;
            // console.log(tmp)
            if (tmp?.code < 2000) {
                setRmFrequencyMonthData(tmp?.data?.monthly_trend ?? []);
            } else if (tmp?.code === 9999) {
                navigate('/');
            }
        } catch (error) {
            console.error(error);
            navigate('/');
        }
    };








    // 연도 변경 시 월 조정
    const handleChangeYear = (e) => {
        const newYear = parseInt(e.target.value, 10);
        setSelectedYear(newYear);

        // 새 연도가 현재 연도이면, 이미 선택된 month가 현재 월보다 크면 조정
        if (newYear === currentYear && selectedMonth > currentMonth) {
            setSelectedMonth(currentMonth);
        }
    };

    // 월 변경
    const handleChangeMonth = (e) => {
        setSelectedMonth(parseInt(e.target.value, 10));
    };

    // 연도 변경 시 월 조정
    const handleChangeRMYear = (e) => {
        const newYear = parseInt(e.target.value, 10);
        setRmSelectedYear(newYear);

        // 새 연도가 현재 연도이면, 이미 선택된 month가 현재 월보다 크면 조정
        if (newYear === currentYear && selectedMonth > currentMonth) {
            setRmSelectedMonth(currentMonth);
        }
    };

    // 월 변경
    const handleChangeRMMonth = (e) => {
        setRmSelectedMonth(parseInt(e.target.value, 10));
    };

    // 경과 시간 표시 예시 함수
    const getDisplayTime = (regDate) => {
        const now = new Date();
        const dateObj = new Date(regDate);
        const kstDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000);
        const diffMs = now - kstDate;

        const diffMinutes = Math.floor(diffMs / (1000 * 60));
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) return `${diffMinutes}분`;
        if (diffHours < 24) return `${diffHours}시간`;
        return `${diffDays}일`;
    };

    // PC화면에서는 아이콘 감춤, 모바일에서는 아이콘 표시
    const renderToggleIcon = (isOpen, iconColor = '#fff') => {
        if (windowWidth > 767) return null;

        const ToggleIcon = isOpen ? ChevronUp : ChevronDown;

        return <ToggleIcon color={iconColor} size={20} />;
    };

    return (
        <div className="flex">
            <div className="content" id="contents">
                <div className="inner-wrap dashboard">
                    <div className="content-container c-left sales">
                        <div className="content-wrap" style={{ paddingBottom: '40px' }}>
                            {/* <div className="content-item">
                                <div className="panel">
                                    <ul className="em">
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowSales(!showSales)
                                                }
                                            }}
                                            style={{ borderBottomLeftRadius: '0', borderBottomRightRadius: '0' }}
                                        >
                                            <strong className="truncate calc-title">실시간 매출</strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item" id="">
                                                    <span style={{ paddingRight: "5px" }}>전일대비</span>
                                                    <span className="day_icon" id="todayPer" style={{ color: "rgb(141, 203, 230)" }}>0%</span>
                                                    <ChevronsDown style={{ display: "inline", color: "rgb(141, 203, 230)" }} />
                                                    <ChevronsUp style={{ display: "inline", color: "rgb(141, 203, 230)" }} />
                                                    <money id="todayTotalAmount" style={{ paddingLeft: "5px" }}>0</money>
                                                    <span>원</span>
                                                </p>
                                                {windowWidth <= 767 && renderToggleIcon(showSales, '#fff')}
                                            </div>
                                        </li>
                                        {showSales && (
                                            <>
                                                <li style={{ height: '57px' }}>
                                                    <strong className="truncate calc-title">
                                                        어제 매출
                                                        <span style={{ fontSize: '0.75rem' }}>
                                                            ({changeNum(Number(dashboardData?.count ?? 0))}건)
                                                        </span>
                                                    </strong>
                                                    <p className="calc-item">
                                                        <money id="pgFee">
                                                            {changeNum(Number(dashabordFeeData?.pgAmount ?? 0))}
                                                        </money>
                                                        <span>원</span>
                                                    </p>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                    <ul className="em">
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowWallet(!showWallet)
                                                }
                                            }}
                                            style={{ borderBottomLeftRadius: '0', borderBottomRightRadius: '0' }}
                                        >
                                            <strong className="truncate calc-title">
                                                바우처지갑
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item" id="">
                                                    <span style={{ paddingRight: "5px" }}>지갑대비</span>
                                                    <span className="day_icon" id="todayPer" style={{ color: "rgb(141, 203, 230)" }}>0%</span>
                                                    <ChevronsDown style={{ display: "inline", color: "rgb(141, 203, 230)" }} />
                                                    <money id="todayTotalAmount" style={{ paddingLeft: "5px" }}>0</money>
                                                    <span>원</span>
                                                </p>
                                                {windowWidth <= 767 && renderToggleIcon(showWallet, '#fff')}
                                            </div>
                                        </li>
                                        {showWallet && (
                                            <>
                                                <li style={{ height: '57px' }}>
                                                    <strong className="truncate calc-title">
                                                        관리자 지갑 총액
                                                    </strong>
                                                    <p className="calc-item">
                                                        <money id="canceledAmount">
                                                            {changeNum(Number((dashboardData?.cancelAmount ?? 0) * -1))}
                                                        </money>
                                                        <span>원</span>
                                                    </p>
                                                </li>
                                            </>
                                        )}
                                    </ul>
                                </div>
                            </div> */}

                            <div className="content-item">
                                <div className="panel">
                                    {/* 1) RM (준비중) */}
                                    <ul style={{ position: 'relative' }}>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowRm(!showRm);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong
                                                className="truncate calc-title"
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    navigate('/sugiListManage');
                                                }}
                                            >
                                                RM - 고액, 다건
                                                {/* <ChevronRight size={20} /> */}
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>{rmAmountCnt}</money>
                                                    <span> 건</span>
                                                </p>
                                                {renderToggleIcon(showRm, '#000')}
                                            </div>
                                        </li>
                                        {showRm &&
                                            rmData
                                                .map((a, i) => (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            gap: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: 'calc(100% - 110px)',
                                                                display: 'flex',
                                                                gap: '10px',
                                                            }}
                                                        >
                                                            <strong
                                                                className="truncate calc-title"
                                                                style={{
                                                                    width: '25px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {a.type == "HIGH_VALUE" ? "고액" : "다건"}
                                                            </strong>
                                                            <div
                                                                className="truncate"
                                                                style={{
                                                                    width: 'calc(100% - 25px)',
                                                                    textAlign: 'left',
                                                                    fontSize: '0.8rem',
                                                                }}
                                                            >
                                                                {a?.co_nm ?? '-'}
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '110px', textAlign: 'right' }}>
                                                            <p className="calc-item">
                                                                <money>{changeNum(Number(a.total_amount))}</money>
                                                                <span>원</span>
                                                                {a.type == "MULTI_TRANSACTION"
                                                                    ?
                                                                    <>
                                                                        <span>/</span>
                                                                        <money>{changeNum(Number(a.total_transactions))}</money>
                                                                        <span>원</span>
                                                                    </>
                                                                    :
                                                                    ""
                                                                }

                                                            </p>
                                                        </div>
                                                    </li>
                                                ))}
                                    </ul>

                                    {/* 실시간거래액 */}
                                    <ul>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowLiveTransaction(!showLiveTransaction);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong className="truncate calc-title">
                                                실시간 거래액
                                                <span style={{ fontSize: '0.75rem' }}>
                                                    (
                                                    {changeNum(Number(dashboardData?.count ?? 0) + Number(dashboardData?.cancelCount ?? 0))}
                                                    건)
                                                </span>
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>
                                                        {changeNum(
                                                            Number(dashboardData?.amount ?? 0) +
                                                            Number(dashboardData?.cancelAmount ?? 0)
                                                        )}
                                                    </money>
                                                    <span>원</span>
                                                </p>
                                                {windowWidth <= 767 && renderToggleIcon(showLiveTransaction, '#000')}
                                            </div>
                                        </li>
                                        {showLiveTransaction && (
                                            <>
                                                <li style={{ height: '57px' }}>
                                                    <strong className="truncate calc-title">
                                                        승인금액
                                                        <span style={{ fontSize: '0.75rem' }}>
                                                            ({changeNum(Number(dashboardData?.count ?? 0))}건)
                                                        </span>
                                                    </strong>
                                                    <p className="calc-item">
                                                        <money id="approvedAmount">
                                                            {changeNum(Number(dashboardData?.amount ?? 0))}
                                                        </money>
                                                        <span>원</span>
                                                    </p>
                                                </li>
                                                <li style={{ height: '57px' }}>
                                                    <strong className="truncate calc-title">
                                                        취소금액
                                                        <span style={{ fontSize: '0.75rem' }}>
                                                            ({changeNum(Number(dashboardData?.cancelCount ?? 0))}건)
                                                        </span>
                                                    </strong>
                                                    <p className="calc-item">
                                                        <money id="canceledAmount">
                                                            {changeNum(Number((dashboardData?.cancelAmount ?? 0) * -1))}
                                                        </money>
                                                        <span>원</span>
                                                    </p>
                                                </li>
                                                <li style={{ height: '57px' }}>
                                                    <strong className="truncate calc-title">
                                                        영업수수료
                                                    </strong>
                                                    <p className="calc-item">
                                                        <money id="canceledAmount">
                                                            {changeNum(Number(dashabordFeeData?.agentAmount ?? 0))}
                                                        </money>
                                                        <span>원</span>
                                                    </p>
                                                </li>
                                            </>
                                        )}
                                    </ul>

                                    {/* 4) 금일예정정산액 */}
                                    <ul>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowSettlementDay(!showSettlementDay);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong className="truncate calc-title">
                                                {MyData?.role ? '익일예정정산액' : '다음달예정정산액'}
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>{changeNum(Number(todaySettlementData?.todaySettlementAmount ?? 0))}</money>
                                                    <span>원</span>
                                                </p>
                                                {windowWidth <= 767 && renderToggleIcon(showSettlementDay, '#000')}
                                            </div>
                                        </li>
                                        {showSettlementDay &&
                                            settlementData.map((a, i) => {
                                                if (a.status === 'success') return null;
                                                return (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                        }}
                                                    >
                                                        <strong className="truncate calc-title">{a.date}</strong>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                gap: '5px',
                                                                alignItems: 'center',
                                                            }}
                                                        >
                                                            <p className="calc-item">
                                                                <money>{changeNum(Number(a.amount))}</money>
                                                                <span>원</span>
                                                            </p>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    gap: '5px',
                                                                    alignItems: 'center',
                                                                }}
                                                            >
                                                                <div
                                                                    // type="button"
                                                                    className="btn btn-primary searchPayBtn"
                                                                    style={{
                                                                        height: '25px',
                                                                        width: '45px',
                                                                        fontSize: '.7rem',
                                                                        padding: '0',
                                                                        backgroundColor: 'darkred',
                                                                        border: "none"
                                                                    }}
                                                                >
                                                                    미처리
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </li>
                                                );
                                            })}
                                    </ul>
                                </div>
                            </div>

                            <div className="content-item">
                                <div className="panel">
                                    {/* 1) RM (준비중) */}
                                    <ul style={{ position: 'relative' }}>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowLiveSales(!showLiveSales);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong
                                                className="truncate calc-title"
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    // navigate('/riskSubmerchants');
                                                }}
                                            >
                                                RM - 가맹점 갱신
                                                {/* <ChevronRight size={20} /> */}
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>0</money>
                                                    {/* <money>{subRenewalCnt}</money> */}
                                                    <span> 건</span>
                                                </p>
                                                {renderToggleIcon(showLiveSales, '#000')}
                                            </div>
                                        </li>
                                        {/* {showLiveSales &&
                                            subRenewal
                                                .map((a, i) => (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            gap: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: 'calc(100% - 110px)',
                                                                display: 'flex',
                                                                gap: '10px',
                                                            }}
                                                        >
                                                            <strong
                                                                className="truncate calc-title"
                                                                style={{
                                                                    width: '45px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {a.created_at}
                                                            </strong>
                                                            <div
                                                                className="truncate"
                                                                style={{
                                                                    width: 'calc(100% - 45px)',
                                                                    textAlign: 'left',
                                                                    fontSize: '0.8rem',
                                                                }}
                                                            >
                                                                {a?.co_nm ?? '-'}
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '110px', textAlign: 'right' }}>
                                                            <p className="calc-item">
                                                                <money>{a?.review_status}</money>
                                                                <span>원</span>
                                                            </p>
                                                        </div>
                                                    </li>
                                                ))} */}
                                        <div
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                background: 'gray',
                                                borderRadius: '5px',
                                                position: 'absolute',
                                                opacity: '0.7',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                fontWeight: 'bold',
                                                fontSize: '18px',
                                            }}
                                        >
                                            준비중입니다.
                                        </div>
                                    </ul>

                                    {/* 2) 수기결제 */}
                                    <ul>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowSogi(!showSogi);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong
                                                className="truncate calc-title"
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (MyData?.role === 'SUPER') {
                                                        navigate('/sugiListManage', { state: { tab: '수기결제' } });
                                                    } else {
                                                        navigate('/sugiManage');
                                                    }
                                                }}
                                            >
                                                수기 결제 신청
                                                {/* <ChevronRight size={20} /> */}
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>{changeNum(Number(dashboardSugiData.length))}</money>
                                                    <span> 건</span>
                                                </p>
                                                {renderToggleIcon(showSogi, '#000')}
                                            </div>
                                        </li>
                                        {showSogi &&
                                            dashboardSugiData
                                                .slice()
                                                .reverse()
                                                .map((a, i) => (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            gap: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: 'calc(100% - 110px)',
                                                                display: 'flex',
                                                                gap: '10px',
                                                            }}
                                                        >
                                                            <strong
                                                                className="truncate calc-title"
                                                                style={{
                                                                    width: '45px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {getDisplayTime(a.reg_date)}
                                                            </strong>
                                                            <div
                                                                className="truncate"
                                                                style={{
                                                                    width: 'calc(100% - 45px)',
                                                                    textAlign: 'left',
                                                                    fontSize: '0.8rem',
                                                                }}
                                                            >
                                                                {a?.co_nm ?? '-'} / {a?.agent_name ?? '-'}
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '110px', textAlign: 'right' }}>
                                                            <p className="calc-item">
                                                                <money>{changeNum(Number(a.req_amount))}</money>
                                                                <span>원</span>
                                                            </p>
                                                        </div>
                                                    </li>
                                                ))}
                                    </ul>

                                    {/* 3) 수기결제취소 */}
                                    <ul>
                                        <li
                                            onClick={() => {
                                                if (windowWidth <= 767) {
                                                    setShowSogiCancel(!showSogiCancel);
                                                }
                                            }}
                                            style={{
                                                borderBottomLeftRadius: '0',
                                                borderBottomRightRadius: '0',
                                                padding: '0.8rem 1rem',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                            }}
                                        >
                                            <strong
                                                className="truncate calc-title"
                                                style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    if (MyData?.role === 'SUPER') {
                                                        navigate('/sugiListManage', { state: { tab: '수기결제취소' } });
                                                    } else {
                                                        navigate('/sugiCancelManage');
                                                    }
                                                }}
                                            >
                                                수기 결제 취소 신청
                                                {/* <ChevronRight size={20} /> */}
                                            </strong>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                                                <p className="calc-item">
                                                    <money>{changeNum(Number(dashboardSugiCancelData.length))}</money>
                                                    <span> 건</span>
                                                </p>
                                                {renderToggleIcon(showSogiCancel, '#000')}
                                            </div>
                                        </li>
                                        {showSogiCancel &&
                                            dashboardSugiCancelData
                                                .slice()
                                                .reverse()
                                                .map((a, i) => (
                                                    <li
                                                        key={i}
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'space-between',
                                                            gap: '15px',
                                                        }}
                                                    >
                                                        <div
                                                            style={{
                                                                width: 'calc(100% - 110px)',
                                                                display: 'flex',
                                                                gap: '10px',
                                                            }}
                                                        >
                                                            <strong
                                                                className="truncate calc-title"
                                                                style={{
                                                                    width: '45px',
                                                                    textAlign: 'right',
                                                                }}
                                                            >
                                                                {getDisplayTime(a.created_at)}
                                                            </strong>
                                                            <div
                                                                className="truncate"
                                                                style={{
                                                                    width: 'calc(100% - 45px)',
                                                                    textAlign: 'left',
                                                                    fontSize: '0.8rem',
                                                                }}
                                                            >
                                                                {a?.name ?? '-'} / {a?.agent_name ?? '-'}
                                                            </div>
                                                        </div>
                                                        <div style={{ width: '110px', textAlign: 'right' }}>
                                                            <p className="calc-item">
                                                                <money>{changeNum(Number(a.amt))}</money>
                                                                <span>원</span>
                                                            </p>
                                                        </div>
                                                    </li>
                                                ))}
                                    </ul>
                                </div>
                            </div>

                            {
                                MyData?.role == "SUPER"
                                    ?
                                    <>
                                        <div className="content-item">
                                            <div className="panel intro-y">
                                                <div className="dailyStatsChart" style={{ width: '100%', height: '100%' }}>
                                                    <div className="main-title-wrap intro-y dashboard-graph">
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '10px',
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <label
                                                                        style={{
                                                                            marginRight: 5,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            value="monthly"
                                                                            checked={period === 'monthly'}
                                                                            onChange={(e) => setPeriod(e.target.value)}
                                                                        />
                                                                        <span style={{ marginLeft: 3, paddingTop: 1 }}>월별</span>
                                                                    </label>

                                                                    <label
                                                                        style={{
                                                                            marginRight: 5,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            value="yearly"
                                                                            checked={period === 'yearly'}
                                                                            onChange={(e) => setPeriod(e.target.value)}
                                                                        />
                                                                        <span style={{ marginLeft: 3, paddingTop: 1 }}>연도별</span>
                                                                    </label>
                                                                </div>

                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px',
                                                                    }}
                                                                >
                                                                    <select
                                                                        id="year_select"
                                                                        className="form-select"
                                                                        style={{
                                                                            height: '30px',
                                                                            padding: '0 10px',
                                                                            fontSize: '12px',
                                                                            width: '70px',
                                                                        }}
                                                                        value={selectedYear}
                                                                        onChange={handleChangeYear}
                                                                    >
                                                                        {yearList
                                                                            .slice()
                                                                            .reverse()
                                                                            .map((y) => (
                                                                                <option key={y} value={y}>
                                                                                    {String(y).substring(2)}년
                                                                                </option>
                                                                            ))}
                                                                    </select>

                                                                    {period === 'monthly' && (
                                                                        <select
                                                                            id="month_select"
                                                                            className="form-select"
                                                                            style={{
                                                                                height: '30px',
                                                                                padding: '0 10px',
                                                                                fontSize: '12px',
                                                                                width: '70px',
                                                                            }}
                                                                            value={selectedMonth}
                                                                            onChange={handleChangeMonth}
                                                                        >
                                                                            {monthList.reverse().map((m) => (
                                                                                <option key={m} value={m}>
                                                                                    {m}월
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <SalesModal
                                                        data={period === 'monthly' ? dailyData : monthData}
                                                        period={period}
                                                        selectedYear={selectedYear}
                                                        selectedMonth={selectedMonth}
                                                    />
                                                    <div style={{ width: "100%", height: '1px', borderBottom: "1px solid #ebebeb", marginBottom: "10px" }}></div>
                                                    <RiskModal
                                                        amountData={period === 'monthly' ? rmAmountDailyData : rmAmountMonthData}
                                                        frequencyData={period === 'monthly' ? rmFrequencyDailyData : rmFrequencyMonthData}
                                                        period={period}
                                                        selectedYear={selectedYear}
                                                        selectedMonth={selectedMonth}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="content-item">
                                            <div className="panel intro-y">
                                                <div className="dailyStatsChart" style={{ width: '100%', height: '100%' }}>
                                                    <div className="main-title-wrap intro-y dashboard-graph">
                                                        <div style={{ display: 'flex', gap: '10px' }}>
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    gap: '10px',
                                                                }}
                                                            >
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <label
                                                                        style={{
                                                                            marginRight: 5,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            value="monthly"
                                                                            checked={rmPeriod === 'monthly'}
                                                                            onChange={(e) => setRmPeriod(e.target.value)}
                                                                        />
                                                                        <span style={{ marginLeft: 3, paddingTop: 1 }}>월별</span>
                                                                    </label>

                                                                    <label
                                                                        style={{
                                                                            marginRight: 5,
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                        }}
                                                                    >
                                                                        <input
                                                                            type="radio"
                                                                            value="yearly"
                                                                            checked={rmPeriod === 'yearly'}
                                                                            onChange={(e) => setRmPeriod(e.target.value)}
                                                                        />
                                                                        <span style={{ marginLeft: 3, paddingTop: 1 }}>연도별</span>
                                                                    </label>
                                                                </div>
                                                                <div
                                                                    style={{
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '5px',
                                                                    }}
                                                                >
                                                                    <select
                                                                        id="year_select"
                                                                        className="form-select"
                                                                        style={{
                                                                            height: '30px',
                                                                            padding: '0 10px',
                                                                            fontSize: '12px',
                                                                            width: '70px',
                                                                        }}
                                                                        value={rmSelectedYear}
                                                                        onChange={handleChangeRMYear}
                                                                    >
                                                                        {yearList
                                                                            .slice()
                                                                            .reverse()
                                                                            .map((y) => (
                                                                                <option key={y} value={y}>
                                                                                    {String(y).substring(2)}년
                                                                                </option>
                                                                            ))}
                                                                    </select>

                                                                    {rmPeriod === 'monthly' && (
                                                                        <select
                                                                            id="month_select"
                                                                            className="form-select"
                                                                            style={{
                                                                                height: '30px',
                                                                                padding: '0 10px',
                                                                                fontSize: '12px',
                                                                                width: '70px',
                                                                            }}
                                                                            value={rmSelectedMonth}
                                                                            onChange={handleChangeRMMonth}
                                                                        >
                                                                            {monthList.reverse().map((m) => (
                                                                                <option key={m} value={m}>
                                                                                    {m}월
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <RiskModal
                                                        amountData={rmPeriod === 'monthly' ? rmAmountDailyData : rmAmountMonthData}
                                                        frequencyData={rmPeriod === 'monthly' ? rmFrequencyDailyData : rmFrequencyMonthData}
                                                        period={rmPeriod}
                                                        selectedYear={rmSelectedYear}
                                                        selectedMonth={rmSelectedMonth}
                                                    />
                                                </div>
                                            </div>
                                        </div> */}
                                    </>
                                    :
                                    ""
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function SalesModal({ data = [], period, selectedYear, selectedMonth }) {
    // 날짜 라벨 포맷 함수 ("2025-03-01" → "25-03-01")
    const formatDateLabel = (val) => {
        if (!val) return '';
        return val.slice(2);
    };

    // 오늘 날짜(시분초 제외)를 구하기 (예: '2025-04-25')
    const getTodayString = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    // period별 날짜/월을 Date 객체로 파싱 (year-month → YYYY-MM-01)
    const parseDate = (value, period) => {
        if (period === 'monthly') {
            // 'YYYY-MM-DD'
            return new Date(`${value}T00:00:00`);
        } else {
            // 'YYYY-MM' → 'YYYY-MM-01'
            return new Date(`${value}-01T00:00:00`);
        }
    };

    const todayStr = getTodayString();
    const todayDate = parseDate(todayStr, 'monthly'); // 'YYYY-MM-DD' 형태 기준

    // =======================
    // X축 rawCategories 생성
    // =======================
    let rawCategories = [];

    if (period === 'monthly') {
        // selectedYear, selectedMonth로 1일부터 말일까지
        const y = String(selectedYear);
        const m = String(selectedMonth).padStart(2, '0');
        const daysInMonth = new Date(+y, parseInt(m, 10), 0).getDate(); // 말일
        rawCategories = Array.from({ length: daysInMonth }, (_, i) => {
            const day = String(i + 1).padStart(2, '0');
            return `${y}-${m}-${day}`;
        });
    } else {
        // 연도 전체 1~12월
        const y = String(selectedYear);
        rawCategories = Array.from({ length: 12 }, (_, i) => {
            const mm = String(i + 1).padStart(2, '0');
            return `${y}-${mm}`;
        });
    }

    // X축 표시용 라벨
    const categories = rawCategories.map((val) => formatDateLabel(val));

    // Y값 생성 로직
    // 데이터 없으면 과거=0, 미래=null
    const seriesData = rawCategories.map((val) => {
        const found =
            period === 'monthly'
                ? data.find((item) => dayjs(item.date).format("YYYY-MM-DD") === val)   // 일별 data
                : data.find((item) => item.month === val); // 월별 data

        const currentDate = parseDate(val, period);

        if (found) {
            // **소수점 제거** (정수로 만들기)
            return parseInt(found.amt >= 0 ? found.amt : 0, 10);
            // 또는 Math.floor(parseFloat(found.amt))
        } else {
            // 데이터가 없으면 과거(오늘 포함)=0, 미래=null
            if (currentDate < todayDate) {
                return 0;
            } else {
                return null;
            }
        }
    });

    // ApexCharts 옵션
    const options = {
        chart: { height: 350, type: 'line' },
        dataLabels: { enabled: false },
        stroke: {
            width: 2,
            curve: 'smooth',
            connectNulls: false,
        },
        xaxis: {
            categories,
            labels: {
                rotate: -60,
                hideOverlappingLabels: true,
                formatter: (value) => {
                    const day = value?.split('-')[2];
                    return String(parseInt(day, 10));
                },
            },
            title: {
                text: '매출그래프',
                style: { fontSize: '14px', fontWeight: 600 },
            },
        },
        yaxis: {
            min: 0,
            labels: {
                formatter: (value) =>
                    Math.floor(value)
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            },
        },
        tooltip: {
            y: {
                formatter: (val) =>
                    val === null
                        ? ''
                        : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '원',
            },
        },
        legend: { position: 'top' },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    xaxis: { tickAmount: 4, labels: { rotate: -90 } },
                    yaxis: { show: false, labels: { show: false } },
                },
            },
        ],
    };

    const series = [
        {
            name: period === 'monthly' ? '일별 매출' : '월별 매출',
            data: seriesData,
        },
    ];

    return (
        <div className="marginTop30 modal_sty">
            <div style={{ height: 'auto' }}>
                <Chart options={options} series={series} type="line" height={300} />
            </div>
        </div>
    );
}

function RiskModal({ amountData = [], frequencyData = [], period, selectedYear, selectedMonth }) {
    const formatDateLabel = (val) => {
        if (!val) return '';
        return val.slice(2);
    };

    const getTodayString = () => {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const parseDate = (value, period) => {
        if (period === 'monthly') {
            return new Date(`${value}T00:00:00`);
        } else {
            return new Date(`${value}-01T00:00:00`);
        }
    };

    const todayStr = getTodayString();
    const todayDate = parseDate(todayStr, 'monthly');

    let rawCategories = [];

    if (period === 'monthly') {
        const y = String(selectedYear);
        const m = String(selectedMonth).padStart(2, '0');
        const daysInMonth = new Date(+y, parseInt(m, 10), 0).getDate();
        rawCategories = Array.from({ length: daysInMonth }, (_, i) => {
            const day = String(i + 1).padStart(2, '0');
            return `${y}-${m}-${day}`;
        });
    } else {
        const y = String(selectedYear);
        rawCategories = Array.from({ length: 12 }, (_, i) => {
            const mm = String(i + 1).padStart(2, '0');
            return `${y}-${mm}`;
        });
    }

    const categories = rawCategories.map((val) => formatDateLabel(val));

    // amountData (좌측 Y축)
    const amountSeriesData = rawCategories.map((val) => {
        const currentDate = parseDate(val, period);
        if (currentDate >= todayDate) return null;

        let found;
        if (period === 'monthly') {
            const day = parseInt(val.split('-')[2], 10);
            found = amountData.find((item) => item.day === day);
        } else {
            const month = parseInt(val.split('-')[1], 10);
            found = amountData.find((item) => item.month === month);
        }

        if (found) {
            const amt = parseInt(found.total_amount, 10);
            return amt >= 0 ? amt : 0;
        } else {
            return 0;
        }
    });

    // frequencyData (우측 Y축)
    const frequencySeriesData = rawCategories.map((val) => {
        const currentDate = parseDate(val, period);
        if (currentDate >= todayDate) return null;

        let found;
        if (period === 'monthly') {
            const day = parseInt(val.split('-')[2], 10);
            found = frequencyData.find((item) => item.day === day);
        } else {
            const month = parseInt(val.split('-')[1], 10);
            found = frequencyData.find((item) => item.month === month);
        }

        if (found) {
            const count = parseInt(found.total_transactions || 0, 10);
            return count >= 0 ? count : 0;
        } else {
            return 0;
        }
    });

    const options = {
        chart: { height: 350, type: 'line' },
        dataLabels: { enabled: false },
        stroke: {
            width: 2,
            curve: 'smooth',
            connectNulls: false,
        },
        xaxis: {
            categories,
            labels: {
                rotate: -60,
                hideOverlappingLabels: true,
                formatter: (value) => {
                    if (typeof value !== 'string') return '';
                    const parts = value.split('-');
                    if (parts.length === 3) {
                        return String(parseInt(parts[2], 10));
                    } else if (parts.length === 2) {
                        return String(parseInt(parts[1], 10));
                    } else {
                        return value;
                    }
                },
            },
            title: {
                text: 'RM 그래프',
                style: { fontSize: '14px', fontWeight: 600 },
            },
        },
        yaxis: [
            {
                title: { text: '매출 (원)' },
                labels: {
                    formatter: (value) =>
                        Math.floor(value)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                },
            },
            {
                opposite: true,
                title: { text: '빈도 (건수)' },
                labels: {
                    formatter: (value) => value?.toString(),
                },
            },
        ],
        tooltip: {
            shared: true,
            y: {
                formatter: (val) =>
                    val === null || val === undefined
                        ? ''
                        : val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','),
            },
        },
        colors: ['#FF0000', '#FF7F00'],
        legend: { position: 'top' },
        responsive: [
            {
                breakpoint: 600,
                options: {
                    xaxis: { tickAmount: 4, labels: { rotate: -90 } },
                    yaxis: [{ show: false }, { show: false }],
                },
            },
        ],
    };

    const series = [
        {
            name: period === 'monthly' ? '일별 매출' : '월별 매출',
            data: amountSeriesData,
        },
        {
            name: period === 'monthly' ? '일별 빈도' : '월별 빈도',
            data: frequencySeriesData,
            yAxisIndex: 1,
        },
    ];

    return (
        <div className="marginTop30 modal_sty">
            <div style={{ height: 'auto' }}>
                <Chart options={options} series={series} type="line" height={300} />
            </div>
        </div>
    );
}

export default Dashboard;